var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.is_init == 1 ? _c("div", [_vm.dataInfo.list.length >= 2 ? _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.dataInfo.list,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "openId",
      label: "OPENID",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleId",
      label: "角色ID",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticClass: "boxInput",
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.roleId) + " ")])];
      }
    }], null, false, 598087923)
  }), _c("el-table-column", {
    attrs: {
      prop: "roleName",
      label: "角色名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "serverId",
      label: "区服ID"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleLevel",
      label: "角色等级"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createRoleTime",
      label: "创角时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lastLoginTime",
      label: "最后登录时间"
    }
  })], 1)], 1) : _vm._e(), _vm.dataInfo.list.length == 1 ? _c("div", [_c("el-form", {
    staticClass: "demo-form-inline",
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "OPENID："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.openId) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "最近登录时间："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.lastLoginTime) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "最后活跃时间："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.lastUpdateTime) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "角色ID："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.roleId) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "角色名："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.roleName) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "区服ID："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.serverId) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "角色等级："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.roleLevel) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "创角时间："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.createRoleTime) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "创角IP："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info.ip) + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "总付费金额："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(Math.ceil(_vm.dataInfo.role_info_pay.total_rmb / 100)) + " 元 ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "首次付费时间："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_info_pay.first_pay_time ? _vm.dataInfo.role_info_pay.first_pay_time : "-") + " ")])]), _c("el-form-item", {
    staticClass: "boxItem",
    attrs: {
      label: "激励视频观看："
    }
  }, [_c("p", {
    staticClass: "boxInput"
  }, [_vm._v(" " + _vm._s(_vm.dataInfo.role_ad_view_count.watchVideoCount) + " ")])])], 1)], 1) : _vm._e(), _vm.dataInfo.ext ? _c("div", {
    staticClass: "title-box"
  }, [_vm._v(" 其他信息 ")]) : _vm._e(), _c("div", [_c("el-form", {
    staticClass: "demo-form-inline",
    attrs: {
      inline: true
    }
  }, _vm._l(_vm.dataInfo.ext, function (val, key) {
    return _c("el-form-item", {
      key: key,
      staticClass: "boxItem",
      attrs: {
        label: key
      }
    }, [_c("p", {
      staticClass: "boxInput"
    }, [_vm._v(" " + _vm._s(val ? val : "-") + " ")])]);
  }), 1)], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };